import { yupResolver } from '@hookform/resolvers/yup';

import {
  object,
  REQUIRED_MESSAGE,
  string,
  match,
  boolean,
} from './general';

const schema = object().shape({
  accessCode: string().required(REQUIRED_MESSAGE),
  password: string().required(REQUIRED_MESSAGE),
  passwordConfirmation: match(
    'password',
    'As senhas devem ser iguais',
  ).required(REQUIRED_MESSAGE),
  legalAgreement: boolean(),
});

export default yupResolver(schema);
